export default "__VITE_ASSET__BGTd4DbN__"